import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_COMMENT',
  CREATE: 'CREATE_COMMENT',
};

export const listComment = submission_id => ({
  type: ACTION.LIST,
  payload: RestClient.request({
    method: 'get',
    url: Constants.API_SUBMISSION_COMMENT,
    params: {
      submission_id,
      ordering: '-id',
    },
  }).catch(err => Promise.reject(err.response.data.detail)),
});

export const createComment = (submission_id, name, description) => {
  const formData = new FormData();
  formData.set('submission_id', submission_id);
  formData.set('name', name);
  formData.set('description', description || '');

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_SUBMISSION_COMMENT,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/project_inspection/submission_comment_actions.js